<template>
  <div class="c-controls">
    <div class="c-controls__group">
      <select v-model="team" @change="chooseVictor" v-if="settings.points">
        <option v-for="team in teams" :key="team.uuid" :value="team.uuid">
          {{ team.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';

export default {
	name: 'ResultsSlide',
	mixins: [BaseSlide],
  methods: {
	  chooseVictor(){
      window.axios.post(`/api/v1/victor/${this.slide.uuid}`, {
        team: this.team,
      }).then(x => {
        console.log('posting victor complete');
      });
    },
  },
  data(){
	  return {
	    team: null,
    };
  },
  computed: {
	  teams(){
	    return this.$actions.getTeams();
    },
    settings(){
	    return this.slide.settings;
    }
  }
};
</script>

<style></style>
